import React from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from '../../ui/Table';
import HistoryTableRow from './HistoryTableRow';

const HistoryTable = ({
  invoiceLabel = 'Фактура',
  invoices = [],
  selectedInvoices = [],
  handleCheckboxChange = () => {},
  sorting,
  setSorting = () => {},
  handleGeneratePdf,
  handleDownloadPdf,
  handleDeleteInvoice,
  handleUpdateInvoice,
  handleLoadInvoiceToForm,
  bankDetails = []
}) => {
  const isSorted = (key, direction) => sorting && sorting.key === key && sorting.direction === direction;

  return (
    <div className="px-6 pb-2">
      <div className="border border-gray-100 rounded-xl overflow-hidden max-h-[400px] overflow-y-auto relative">
        <Table>
          <Thead className="sticky top-0 z-10 bg-gray-50">
            <Tr>
              <Th className="w-12 text-center"></Th>
              <Th>
                <div className="flex items-center gap-2">
                  {invoiceLabel}
                  <div className="flex flex-col cursor-pointer">
                    <span onClick={() => setSorting({ key: 'invoiceNumber', direction: 'asc' })} className={`text-[10px] -mb-1 ${isSorted('invoiceNumber', 'asc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▲</span>
                    <span onClick={() => setSorting({ key: 'invoiceNumber', direction: 'desc' })} className={`text-[10px] ${isSorted('invoiceNumber', 'desc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▼</span>
                  </div>
                </div>
              </Th>
              <Th>
                <div className="flex items-center gap-2">
                  Получател
                  <div className="flex flex-col cursor-pointer">
                    <span onClick={() => setSorting({ key: 'receiverName', direction: 'asc' })} className={`text-[10px] -mb-1 ${isSorted('receiverName', 'asc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▲</span>
                    <span onClick={() => setSorting({ key: 'receiverName', direction: 'desc' })} className={`text-[10px] ${isSorted('receiverName', 'desc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▼</span>
                  </div>
                </div>
              </Th>
              <Th>
                <div className="flex items-center gap-2">
                  Създадена
                  <div className="flex flex-col cursor-pointer">
                    <span onClick={() => setSorting({ key: 'creationDate', direction: 'asc' })} className={`text-[10px] -mb-1 ${isSorted('creationDate', 'asc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▲</span>
                    <span onClick={() => setSorting({ key: 'creationDate', direction: 'desc' })} className={`text-[10px] ${isSorted('creationDate', 'desc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▼</span>
                  </div>
                </div>
              </Th>
              <Th>
                <div className="flex items-center gap-2">
                  Стойност
                  <div className="flex flex-col cursor-pointer">
                    <span onClick={() => setSorting({ key: 'totalAmount', direction: 'asc' })} className={`text-[10px] -mb-1 ${isSorted('totalAmount', 'asc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▲</span>
                    <span onClick={() => setSorting({ key: 'totalAmount', direction: 'desc' })} className={`text-[10px] ${isSorted('totalAmount', 'desc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▼</span>
                  </div>
                </div>
              </Th>
              <Th className="text-right">Действия</Th>
            </Tr>
          </Thead>
          <Tbody>
            {invoices.length === 0 ? (
              <Tr>
                <Td colSpan={6} className="text-center text-gray-500 py-8">Няма намерени фактури</Td>
              </Tr>
            ) : (
              invoices.map((inv) => (
                <HistoryTableRow 
                  key={inv.id}
                  inv={inv}
                  isChecked={selectedInvoices.includes(inv.id)}
                  handleCheckboxChange={handleCheckboxChange}
                  handleGeneratePdf={handleGeneratePdf}
                  handleDownloadPdf={handleDownloadPdf}
                  handleUpdateInvoice={handleUpdateInvoice}
                  handleLoadInvoiceToForm={handleLoadInvoiceToForm}
                  handleDeleteInvoice={handleDeleteInvoice}
                  bankDetails={bankDetails}
                />
              ))
            )}
          </Tbody>
        </Table>
      </div>
    </div>
  );
};

export default HistoryTable;
